import axios, { AxiosPromise } from "axios";

//TODO: add result class
export const getEvents = (): AxiosPromise<any> => axios.get(`/api/events`);
